
import clsBaseGlobal from './base'

const arrFillable = [
    "widgets",
];


class clsGlobalDashboard extends clsBaseGlobal {

    widgets     = null;

    /**
     * Get a copy of the widget array.
     * @returns 
     */    
    getWidgets() {
        return [...this.widgets];
    }

    /**
     * Is the widget with the given id in our configuration?
     */
    hasWidget(id_widget) {
        return !!(this.widgets||[]).find( (id) => id == id_widget);
    }

    fill(data) {
        data = data ||{};
        data.widgets  = data.widgets ||[];
        return super.fill(data);
    }

    get fillable() { return arrFillable; }

}

export default clsGlobalDashboard;